module.exports = __webpack_public_path__ + "img/img14.6d1ac849.jpg";